import { useRouter } from 'next/router';
import { ReactNode, useEffect } from 'react';

import useConfirmedSession from '../../hooks/useConfirmedSession';

const AuthGuardProvider = ({
  allowUnAuthenticated,
  children,
}: {
  children: ReactNode;
  allowUnAuthenticated?: boolean;
}) => {
  const router = useRouter();
  const { isConfirmedSignedOut } = useConfirmedSession();

  // Gated on `isConfirmedSignedOut`, not `session.status`: NextAuth reports a FAILED
  // /api/auth/session fetch as `unauthenticated`, so a wifi blip used to bounce a
  // signed-in teacher to /login from any page under NewAppLayout. While the session is
  // merely interrupted we keep rendering and let useConfirmedSession repair it.
  useEffect(() => {
    if (allowUnAuthenticated) return;
    if (isConfirmedSignedOut) {
      router.replace(`/login?redirect=${encodeURIComponent(router.asPath)}`);
    }
  }, [allowUnAuthenticated, isConfirmedSignedOut, router]);

  // Blank only while the redirect above is in flight. 'loading', 'authenticated' and an
  // interrupted session all keep the page mounted.
  if (!allowUnAuthenticated && isConfirmedSignedOut) return <></>;
  return <>{children}</>;
};

export default AuthGuardProvider;
